/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2025-04-12 14:02:15
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-04-17 14:16:54
 * @FilePath: \vue-hepha-order\src\views\inventoryLock\queryConfig\InventoryLockListQuery.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const InventoryLockListQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            key:'sku',
            type:'input',   
            allowClear:true,
            width:'230px',
            placeholder:'product.sku',
        },
    ]
}

const ViewListQuery = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0',
    formData:{},
    formField:[
        {
            key:'order_name',
            type:'input',   
            allowClear:true,
            width:'230px',
            placeholder:'inventoryLock.orderName',
        },
        {
            key:'inventory_type',
            type:'select',   
            allowClear:true,
            width:'230px',
            placeholder:'inventoryLock.type',
            optionToLocale:true,
            options:[
                {
                    label:'inventoryLock.inStock',
                    value:'in_stock',
                },
                {
                    label:'inventoryLock.inTransit',
                    value:'in_transit',
                },
                {
                    label:'inventoryLock.productionPlan',
                    value:'production_plan',
                }
            ]
        },
        {
            key:'lock_status',
            type:'select',   
            allowClear:true,
            width:'230px',
            placeholder:'inventoryLock.lockStatus',
            optionToLocale:true,
            options:[
                {
                    label:'inventoryLock.overdue',
                    value:0,
                },
                {
                    label:'inventoryLock.locked',
                    value:1,
                },
                {
                    label:'inventoryLock.finish',
                    value:2,
                }
            ]
        },
        {
            key:'warehouse',
            type:'select',   
            allowClear:true,
            width:'230px',
            placeholder:'inventoryLock.warehouse',
            optionToLocale:true,
            options:[
                {
                    value:'HFFG01',
                    label:'Maisach'
                },
                {
                    value:'HFFG05',
                    label:'Central Warehouse'
                },
            ]
        },
        {
            key:'order_channel_type',
            type:'select',   
            allowClear:true,
            width:'230px',
            placeholder:'order.orderChannelType',
            optionToLocale:true,
            options:[
                {
                    value:0,
                    label:'order.user'
                },
                {
                    value:1,
                    label:'order.dealer'
                },
                {
                    value:3,
                    label:'order.notForSale'
                },
                {
                    value:5,
                    label:'order.c2c'
                },
            ]
        },
    ]
}

const AddForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    formData:{},
    formField:[
        {
            name:'plan.recordYear',//年份
            key:'record_year',
            type:'yearDate',   
            allowClear:true,
            required:true,
            disabled:false,
            width:'420px',
        },
        {
            name:'plan.recordWeek', // 周别
            key:'record_date',
            type:'weekDate',   
            allowClear:true,
            required:true,
            disabled:false,
            width:'420px',
        },
    ]
}

InventoryLockListQuery.formField.forEach(item=>{
    InventoryLockListQuery.formData[item.key] = ''
})

ViewListQuery.formField.forEach(item=>{
    ViewListQuery.formData[item.key] = ''
})

export {
    InventoryLockListQuery,
    ViewListQuery,
}